import React from 'react';
import { Form, Input } from 'antd';
import { translate } from 'react-i18next';

const FormItem = Form.Item;

const FIELDS = [
  'royalties',
  'fees',
  'state',
  'dailyPrice',
  'daysCount',
  'searchFees',
  'exceptionalCost',
  'makingCost',
  'rightToImage',
];

export class Prices extends React.Component {
  static defaultProps = {
    onChange () {},
  };

  constructor (props) {
    super(props);

    FIELDS.forEach(name => {
      this[`set${name}`] = ({ target: { value } }) => {
        const { pricing } = this.state;
        this.setState({
          pricing: {
            ...pricing,
            [name]: value,
          },
        });
      };
    });
  }

  state = {
    pricing: this.props.initialValue || {},
  };

  componentDidUpdate (prevProps, { pricing: prevPricing }) {
    const { onChange } = this.props;
    const { pricing } = this.state;

    if (pricing !== prevPricing) {
      onChange(pricing);
    }
  }

  render () {
    const { pricing } = this.state;
    const { t } = this.props;

    return (
      <fieldset>
        {FIELDS.map(name => (
          <FormItem
            key={name}
            label={t(name)}
          >
            <Input
              type="number"
              value={pricing[name]}
              onChange={this[`set${name}`]}
              min={0}
            />
          </FormItem>
        ))}
      </fieldset>
    );
  }
}

export default translate('PricesForm')(Prices);



// WEBPACK FOOTER //
// ./src/components/Userrequest/PricesForm.js